// ts-rest contract for Comply > Regulatory Capital.
// Read-only projection of the RegulatoryCapitalSnapshot Object Type (firm IFPR /
// ICARA position, one row per reporting date). The DTO mirrors the object shape
// 1:1; readers sort newest-first.

import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const regCapitalSnapshotDtoSchema = z.object({
    id: z.string(),
    date: z.string(),
    ownFunds: z.number(),
    ownFundsRequirement: z.number(),
    ownFundsRatio: z.number(),
    fixedOverheadRequirement: z.number(),
    kAUM: z.number(),
    kCMH: z.number(),
    kCOH: z.number(),
    totalKFactorRequirement: z.number(),
    liquidAssets: z.number(),
    liquidAssetsRequirement: z.number(),
    liquidAssetsRatio: z.number(),
    windDownPeriod: z.number(),
    icaraBuffer: z.number(),
    ragStatus: z.enum(['Red', 'Amber', 'Green']),
});
export type RegCapitalSnapshotDto = z.infer<typeof regCapitalSnapshotDtoSchema>;

export const regCapitalResponseSchema = z.object({
    snapshots: z.array(regCapitalSnapshotDtoSchema),
});
export type RegCapitalResponse = z.infer<typeof regCapitalResponseSchema>;

const errorBody = z.object({ error: z.string() });

export const complyRegCapitalContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/comply/reg-capital',
            responses: { 200: regCapitalResponseSchema, 403: errorBody },
            summary: 'Firm IFPR / ICARA regulatory-capital snapshots (latest first).',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
